import {
    isRequired,
    isEmail,
    containsNonPrintables,
    isBoolNotSet,
} from "~/assets/js/Helpers/validators";

export const validate = (values) => {
    const errors = {};

    errors.deliveryAddress = validateAddressData(
        values.deliveryAddress,
        values.is_company
    );

    if (!values.sameAsBilling) {
        errors.billingAddress = validateAddressData(
            values.billingAddress,
            values.is_company
        );
    }

    if (isRequired(values.phone)) {
        errors.phone = "form.errors.required";
    }

    if (isRequired(values.email)) {
        errors.email = "form.errors.required";
    } else if (isEmail(values.email)) {
        errors.email = "form.errors.email";
    }

    if (isBoolNotSet(values.is_company)) {
        errors.is_company = "form.errors.required";
    }

    // Remove empty validation fields
    if (errors.deliveryAddress === undefined) delete errors.deliveryAddress;
    if (errors.billingAddress === undefined) delete errors.billingAddress;

    return errors;
};

const validateAddressData = (values, isCompanyOrder) => {
    const errors = {};

    if (containsNonPrintables(values.first_name)) {
        errors.first_name = "form.errors.containsNonPrintables";
    }

    if (containsNonPrintables(values.last_name)) {
        errors.last_name = "form.errors.containsNonPrintables";
    }

    if (containsNonPrintables(values.address)) {
        errors.address = "form.errors.containsNonPrintables";
    }

    if (containsNonPrintables(values.address_2)) {
        errors.address_2 = "form.errors.containsNonPrintables";
    }

    if (containsNonPrintables(values.city)) {
        errors.city = "form.errors.containsNonPrintables";
    }

    if (containsNonPrintables(values.company)) {
        errors.company = "form.errors.containsNonPrintables";
    }
    if (isCompanyOrder && isRequired(values.company)) {
        errors.company = "form.errors.required";
    }

    if (isCompanyOrder && isRequired(values.legal_form)) {
        errors.legal_form = "form.errors.required";
    }

    if (isRequired(values.first_name)) {
        errors.first_name = "form.errors.required";
    }

    if (isRequired(values.last_name)) {
        errors.last_name = "form.errors.required";
    }

    if (isRequired(values.address)) {
        errors.address = "form.errors.required";
    }

    if (isRequired(values.postcode)) {
        errors.postcode = "form.errors.required";
    }

    if (isRequired(values.city)) {
        errors.city = "form.errors.required";
    }

    if (Object.keys(errors).length !== 0) return errors;
};
